import axiosInstance from '../../../../config/axiosInstance';
import { PartFinancialValidation } from "../../views/PartFinancial/Validation/PartFinancialValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  event.preventDefault();
  const formErrors = PartFinancialValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreatePartFinancial`, formData);
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };